import style from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function SingleBox({ list, selectFn, defaultSelect }: any) {
    const { useState, gtm } = useGlobal();

    const [activeItem, setActiveItem] = useState(defaultSelect);

    return (
        <div className={style.singleBox}>
            {list.map((item: string) => {
                return (
                    <span
                        key={item}
                        className={`single-item ${activeItem === item && 'active'}`}
                        onClick={() => {
                            if (item === activeItem) return;
                            setActiveItem(item);
                            selectFn(item);
                            gtm.push({
                                event: 'uaEvent',
                                event_name: 'pre_order_second_navigation',
                                navigation_name: `Bundles_${item || ''}`,
                            });
                            window?.fbq && window?.fbq('track', 'FindLocation');
                        }}
                    >
                        {item}
                    </span>
                );
            })}
        </div>
    );
}
